import React from 'react';
import { Button, Row, Table } from 'antd';
import {
  SmartFormLabel,
  SmartNumberInput,
  SmartScanner,
  SmartScannerInput,
  SmartSpace,
} from 'components/Sales/Smart/SmartComponent';
import {
  SecondaryButton,
  message,
} from 'components/common';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_FLASH_MSG_DISPLAY_DURATION,
  //COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  //HTTP_STATUS_OK,
} from 'constants/config';
import {
  //fetchWarehousePostedTransferDetailByBatchNumber,
  fetchTransferLines,
  transferReceive,
} from 'services/inventory';
import { playSound } from 'utils';
import { isCodeMatchLine, isLineItemCode } from './WMSReceive';
import { WHTActionType as WHTAction, WMSRecvStep } from './context';

type Props = ReduxStateProps & {
};

enum QtyEdit {
  AutoAddOne,
  ManualInput,
};

const ScanSku = (props: Props) => {
  const { useState } = React;
  const [batchLines, setBatchLines] = useState<StringKAnyVPair[]>([]);
  const [batchLineVersion, setBatchLineVersion] = useState(0);
  const [inited, setInited] = useState(false);
  const [itemRecvQty, setItemRecvQty] = useState<number>();
  const [itemRecvQtyInputVersion, setItemRecvQtyInputVersion] = useState(0);
  const [itemScannerCode, setItemScannerCode] = useState('');
  const [itemScannerVersion, setItemScannerVersion] = useState(0);
  const [qtyEditMode, setQtyEditMode] = useState<QtyEdit>(QtyEdit.AutoAddOne);

  const ctnRef = React.useRef<any>(null);

  const columns = [
    {
      title: 'SKU',
      dataIndex: 'sku',
    },
    /*{
      title: 'Processed Qty',
      dataIndex: 'waitCloseQty',
      render(wcq: number, row: any) {
        //console.log('r', wcq, row);
        return wcq + row.receivingQty;
      },
    },*/
    {
      title: 'Scanned Qty',
      dataIndex: 'receivingQty',
    },
  ];

  const listManualInputRowProps = (row: StringKAnyVPair, idx: any) => {
    return {
      onClick() {
        onClickManualInputTableRow(row);
      },
    };
  };

  const handleScannerAutoSubmit = (val: string) => {
    const itemCode = val.trim();
    //const line = batchLines.find(e => e.sku === itemCode);
    const line = batchLines.find(e => isCodeMatchLine(itemCode, e));

    if (!itemCode) {
      return;
    }

    if (line) {
      handleSubmitLine(line, 1);
    } else {
      playSound('error');
      message.error({
        content: `No item(${itemCode}) found`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    }
  };

  const handleSubmitLine = async (line: StringKAnyVPair, recvQty: number) => {
    const { dispatch, state } = props;
    console.log('r', line, recvQty);
    dispatch({ type: WHTAction.SetLockScreen, params: true });
    try {
      const params = batchLines.filter(e => e.fulfillmentTransferLineNum === line.fulfillmentTransferLineNum).map((item) => {
        return {
          // FulfillmentPoLineNum: item.poLineNum,
          FulfillmentTransferLineNum: item.fulfillmentTransferLineNum,
          // FulfillmentProductNum: item.productNum,
          //ReceiveQty: item.fulfillmentTransferLineNum === line.fulfillmentTransferLineNum ? recvQty : item.receiveQty,
          ReceiveQty: recvQty,
          LocationNum: item.receivingLocationNum,
          Note: item.notes,
          // LocationCode: item.receivingLocationCode,
          // WarehouseCode: warehouse.code,
          // PoPrice: item.price || 0,
          // ReceiptDate: moment(dateString),
        };
      });
      const res = await transferReceive(
        state.selectedWarehouse.warehouseId,
        state.currentWMSBatch.transferNum,
        params,
      );

      if (res) {
        //const bl = batchLines.find(e => e.sku === line.sku);
        const bl = batchLines.find(e => isCodeMatchLine(e.sku, line));

        //console.log('fb', bl);
        if (bl) {
          bl.receivingQty = bl.receivingQty + recvQty;
          bl.receiveQty = bl.receiveQty + recvQty;
          bl.receivingTimestamp = (new Date()).getTime();
          setBatchLines([...batchLines]);
          setBatchLineVersion(batchLineVersion + 1);
          (qtyEditMode === QtyEdit.ManualInput) && onClearScannedItem();
        }

        playSound('success');
        message.success({
          content: 'Received successfully',
          duration: COMMON_FLASH_MSG_DISPLAY_DURATION,
        });
      } else {
        playSound('error');
        message.error({
          content: 'Receiving failed',
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
      }
    } catch(e) {
      message.error({
        content: `Received error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: WHTAction.SetLockScreen, params: false });
    }
  };

  const handleSubmitManualInput = () => {
    const line = batchLines.find(e => isLineItemCode(e, itemScannerCode));

    line && (typeof itemRecvQty === 'number' && itemRecvQty > 0) && handleSubmitLine(line, itemRecvQty);
  };

  // eslint-disable-next-line
  const loadTransferLines = async () => {
    const { dispatch, state } = props;
    //console.log('s', state.currentWMSBatch, state.recvLocation);
    dispatch({ type: WHTAction.SetLockScreen, params: true });
    try {
      const lines = await fetchTransferLines(
        state.selectedWarehouse.warehouseId,
        state.currentWMSBatch.transferNum,
      );
      console.log('l', lines);
      setBatchLines(
        lines.map((item: any) => {
          return {
            ...item,
            receivingLocationCode: state.recvLocation.locationCode,
            receivingLocationNum: state.recvLocation.locationNum,
            receivingQty: 0,
            receivingTimestamp: 0,
          };
        })
      );
    } catch(e) {
      message.error({
        content: `Loaded lines error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      dispatch({ type: WHTAction.SetLockScreen, params: false });
    }
  };

  const isManualInputSubmittable = () => {
    return isRecvQtyEnabled() && (typeof itemRecvQty === 'number' && itemRecvQty > 0);
  };

  const isRecvQtyEnabled = () => {
    return batchLines.find(e => isLineItemCode(e, itemScannerCode));
  };

  const onClearScannedItem = () => {
    setItemRecvQty(undefined);
    setItemRecvQtyInputVersion(itemRecvQtyInputVersion + 1);
    setItemScannerCode('');
    setItemScannerVersion(itemScannerVersion + 1);
  };

  const onClickManualInputTableRow = (row: StringKAnyVPair) => {
    //console.log('c', row);
    onScanItem(row.sku);
  };

  const onItemRecvQtyChange = (val: any) => {
    //console.log('v', typeof val, val);
    typeof val === 'number' ? setItemRecvQty(val) : setItemRecvQty(undefined);
  };

  const onItemScannerChange = (evt: any) => {
    const lc = evt.target.value.trim();
    //console.log('c', evt.target.value);
    setItemScannerCode(lc);
  };

  const onItemScannerKeyDown = (evt: any) => {
    if ([9, 13].indexOf(evt.keyCode) > -1) {
      evt.preventDefault();
    }
  };

  const onScanItem = (itemCode: string) => {
    const lc = itemCode.trim();

    setItemScannerCode(lc);

    if (batchLines.find(e => isLineItemCode(e, lc))) {
      playSound('bell');

      if (ctnRef.current) {
        const qtyInput = ctnRef.current.querySelector('#recv-num-input');

        //console.log(qtyInput, '<-');
        qtyInput && setTimeout(() => qtyInput.focus(), 0);
      }
    } else {
      playSound('error');
      message.error({
        content: `No item(${lc}) found`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    }
  };

  const scannedLines = (onlyScanned = false) => {
    const lines = onlyScanned ? batchLines.filter(e => e.receivingQty > 0) : batchLines;

    return lines.sort((a, b) => b.receivingTimestamp - a.receivingTimestamp);
  };

  const switchRecvLocation = () => {
    const { dispatch } = props;

    dispatch({ type: WHTAction.SetWMSRecvStep, params: WMSRecvStep.ScanLocation });
  };

  const useManualInputQtyMode = () => {
    setQtyEditMode(QtyEdit.ManualInput);
  };

  React.useEffect(() => {
    if (!inited) {
      setTimeout(() => {
        loadTransferLines();
      }, 0);
      setInited(true);
    }
  }, [inited, loadTransferLines]);

  return (<>
    <SmartSpace ref={ctnRef}>
      {qtyEditMode === QtyEdit.AutoAddOne && (<>
        <SmartFormLabel className="fs-18 mb-10 text-bold2 text-green-label">Scan SKU to receive</SmartFormLabel>
        <SmartScanner
          //disabled={isFetching}
          isAutoFocus={1}
          placeholder="Input Item here"
          onChangeValue={handleScannerAutoSubmit}
        />
        {scannedLines(true).length > 0 && (
          <Table
            className="mt-20"
            columns={columns}
            dataSource={scannedLines(true)}
            key={`line-tb-${batchLineVersion}`}
            //onRow={listRowProps}
            pagination={false}
            rowKey="fulfillmentTransferLineNum"
            //scroll={{y: tableScrollHeight()}}
            size="middle"
          />
        )}
      </>)}
      {qtyEditMode === QtyEdit.ManualInput && (<>
        <Row align="middle" className="mt-20" justify="space-between">
          <SmartFormLabel className="fs-18 mr-8 text-bold2 text-green-label">SKU</SmartFormLabel>
          <SmartScannerInput
            allowClear
            autoFocus
            className="fs-22 h-50"
            //disabled={isFetching}
            onChange={onItemScannerChange}
            onClear={onClearScannedItem}
            onKeyDown={onItemScannerKeyDown}
            onScan={onScanItem}
            placeholder="Input Item here"
            style={{ width: 'calc(100% - 50px)' }}
            updateValue={itemScannerCode}
            version={itemScannerVersion}
          />
        </Row>
        <Row align="middle" className="mt-20" justify="space-between">
          <SmartFormLabel className="fs-18 mr-8 text-bold2 text-green-label">Qty</SmartFormLabel>
          <SmartNumberInput
            className="num-input h-50"
            disabled={!isRecvQtyEnabled()}
            id="recv-num-input"
            min={0}
            onChange={onItemRecvQtyChange}
            style={{ width: 'calc(100% - 50px)' }}
            value={itemRecvQty}
            version={itemRecvQtyInputVersion}
          />
        </Row>
        <Row className="mt-20" justify="center">
          <Button
            className="h-45 max-w-250 w-250"
            disabled={!isManualInputSubmittable()}
            onClick={handleSubmitManualInput}
            type="primary"
            size="large"
            //style={{marginBottom: 0}}
          >
            Submit
          </Button>
        </Row>
        {batchLines.length > 0 && (
          <Table
            className="mt-20"
            columns={columns}
            dataSource={scannedLines()}
            key={`line-tb-${batchLineVersion}`}
            onRow={listManualInputRowProps}
            pagination={false}
            rowKey="fulfillmentTransferLineNum"
            //scroll={{y: tableScrollHeight()}}
            size="middle"
          />
        )}
      </>)}
      <Row className="mt-20" justify="center">
        <SecondaryButton
          className="h-45 max-w-250 w-250"
          onClick={switchRecvLocation}
          size="large"
          //style={{marginBottom: 0}}
          type="primary"
        >
          Start from a different location
        </SecondaryButton>
      </Row>
      {qtyEditMode === QtyEdit.AutoAddOne && (<>
        <Row className="mt-20" justify="center">
          <Button
            className="h-45 max-w-250 w-250"
            onClick={useManualInputQtyMode}
            size="large"
            //style={{marginBottom: 0}}
            //type="primary"
          >
            I don't have a scanner
          </Button>
        </Row>
      </>)}
    </SmartSpace>
  </>);
};

export default ScanSku;
